import axiosInstance from "@/store/axios.instance";

export default {
    namespaced: true,
    state (){
        return{
            telescopen: null,
            telescoop: null,
        }
    },
    mutations: {
        setTelescopen (state, telescopen){
            state.telescopen = telescopen
        },
        setTelescoop (state, telescoop){
            state.telescoop = telescoop
        }
    },
    actions: {
        async fetchTelescopen ({commit}){
            await axiosInstance.get('/zon/telescopen')
                .then(result => commit('setTelescopen', result.data))
        },
        fetchTelescoopById ({commit}, id){
           axiosInstance.get('/zon/telescopen/' + id)
                .then(result => commit('setTelescoop',result.data))
        },
        fetchTelescoopByName ({commit}, naam){
            axiosInstance.get('/zon/telescopen/telescoopMetNaam/' + naam)
                .then(result => commit('setTelescoop',result.data))
        },
        createTelescope({ commit, dispatch }, telescoop) {
            return axiosInstance.post('/zon/telescopen/', telescoop)
                .then(result => {
                    commit('setTelescoop', result.data)
                    return dispatch('fetchTelescopen')
                });
        }
    }
}